/* This is a generated file. Do not edit manually. */
import React from 'react';
import PropTypes from 'prop-types';
import iconSizes from '../../iconSizes';

/**
 * VolumeUpIcon
 */
export default class VolumeUpIcon extends React.Component {
  static propTypes = {
    /** The size of the icon */
    size: PropTypes.oneOf(['s', 'm', 'l', 'xl']),
    /** The color of the icon */
    color: PropTypes.string.isRequired
  };

  static defaultProps = {
    size: 'm',
    color: 'black'
  };

  render() {
    const { size: sizeProp, color } = this.props;
    const size = correctButtonSize(sizeProp);
    return (
      <svg
        focusable="false"
        xmlns="http://www.w3.org/2000/svg"
        viewBox={'0 0 32 32'}
        style={{ width: iconSizes[size], height: iconSizes[size] }}
      >
        <g style={{ fill: color }}>
          <svg viewBox="0 0 24 24"><path d="M20.888 2.54C22.298 5.26 23 8.418 23 12c0 3.582-.702 6.74-2.112 9.46a1 1 0 11-1.776-.92C20.368 18.117 21 15.275 21 12c0-3.275-.632-6.117-1.888-8.54a1 1 0 111.776-.92zm-3.056 1.905C19.278 6.615 20 9.141 20 12s-.722 5.386-2.168 7.555a1 1 0 11-1.664-1.11C17.388 16.615 18 14.475 18 12c0-2.474-.611-4.614-1.832-6.445a1 1 0 111.664-1.11zM11 4.415a2 2 0 011.995 1.85l.005.15v11.17a2 2 0 01-3.287 1.532L9.586 19l-3-3H4a2 2 0 01-1.995-1.85L2 14v-4a2 2 0 011.85-1.995L4 8h2.586l3-3A2 2 0 0111 4.414zm0 2L7.707 9.706a1 1 0 01-.576.284L7 10H4v4h3a1 1 0 01.608.206l.1.087L11 17.586V6.414zm3.553.69a1 1 0 011.341.448C16.63 9.02 17 10.507 17 12c0 1.493-.371 2.979-1.106 4.447a1 1 0 01-1.788-.894c.599-1.198.894-2.38.894-3.553s-.295-2.355-.894-3.553a1 1 0 01.447-1.341z" fillRule="nonzero"/></svg>
        </g>
      </svg>
    );
  }
}

/* corrects deprecated api, can be removed in future release */
function correctButtonSize(size) {
  switch (size) {
    case 'medium':
      return 'm';
    case 'small':
      return 's';
    case 'large':
      return 'l';
    case 'xlarge':
      return 'xl';
    default:
      return size;
  }
}

